import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import Brands from "@/components/Brands";
import SavingsCalculator from "@/components/SavingsCalculator";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CallbackWidget from "@/components/CallbackWidget";
import Imprint from "@/pages/Imprint";

function Home() {
  return (
    <div className="App relative" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Brands />
        <SavingsCalculator />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Home /><CallbackWidget /></>} />
          <Route path="/imprint" element={<><Imprint /><CallbackWidget /></>} />
          <Route path="*" element={<><Home /><CallbackWidget /></>} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontFamily: "Manrope, sans-serif",
              border: "1px solid hsl(30 12% 86%)",
            },
          }}
        />
      </BrowserRouter>
    </LanguageProvider>
  );
}
